<template>
	<b-form-group>
		<template v-slot:label>
			{{ label }}
		</template>
		<b-input-group v-if="editable" size="sm">
			<b-form-input
				type="text"
				size="sm"
				:value="place.name"
				readonly
				required
			/>
			<template v-slot:prepend>
				<b-button
					v-if="locationUrl"
					:href="locationUrl"
					target="_blank"
					variant="success"
					size="sm"
				>
					<md-icon :icon="placeTypeIcon" />
				</b-button>
				<b-input-group-text v-else
					><md-icon :icon="placeTypeIcon"
				/></b-input-group-text>
			</template>
			<template v-slot:append>
				<!-- deshabilita edicion para volver a realizar la busqeuda-->
				<b-button
					v-if="!unableEdit"
					variant="primary"
					@click="editable = false"
					><md-icon icon="edit"></md-icon
				></b-button>
				<b-button
					v-if="!placeHasValidLocation"
					variant="warning"
					@click="() => openPlace(place.id)"
					><md-icon icon="not_listed_location"
				/></b-button>
			</template>
		</b-input-group>

		<vue-typeahead-bootstrap
			v-else
			showAllResults
			size="sm"
			placeholder="Buscar"
			v-model="search"
			:serializer="place => place.name"
			:data="searchData"
			@hit="selected => setPlace(selected)"
		>
			<template v-slot:suggestion="{ data, htmlText }">
				<span v-html="htmlText"></span><br /><small>{{
					data.address
				}}</small>
			</template>
			<template v-slot:prepend>
				<b-input-group-text
					><md-icon :icon="placeTypeIcon"
				/></b-input-group-text>
			</template>
			<template v-slot:append>
				<!-- habilita edicion para bloquear la edicion -->
				<b-button variant="primary" @click="editable = true">
					<b-spinner v-if="loading" small />
					<span v-else>X</span>
				</b-button>
			</template>
		</vue-typeahead-bootstrap>
		<PlaceSingle ref="placeSingle" />
	</b-form-group>
</template>

<script>
import { debounce } from "debounce";
import api from "@/api.js";
import PlaceSingle from "@/components/sections/places/Single.vue";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
export default {
	components: {
		VueTypeaheadBootstrap,
		PlaceSingle
	},
	props: {
		label: String,
		index: Number,
		place: Object,
		copyFromId:Number,
		placeId: [Number, String],
		unableEdit: Boolean,
		formTypeWork:{
			type: String,
			required: false
		},
	},
	data: () => ({
		editable: false,
		search: "",
		loading: false,
		searchData: []
	}),
	updated(){
		// console.log("Location input service:"+this.formTypeWork+" -> "+this.place.name);
		// if(this.place.name.length > 0){
		// 	if(this.copyFromId!=null || this.copyFromId>0){
		// 		this.editable=true;
		// 		return;
		// 	}
		// }
		// //deshabilita edicion
		// this.editable=false;
	},
	mounted() {
		// this.searchPlace(this.search);
		//formTypeWork = [viewForm - newForm - newFormCopy - newFormLocationReferences]
		this.initialize();



		// if (this.isNew && !this.place.name)  this.editable = true;
		//es un nuevo formulario?
		// if(this.isNew==-1){
		// 	//existe un id de referencia para duplicar/copiar
		// 	if(this.copyFromId!=null && this.copyFromId>0){
		// 		//habilita edicion
		// 		this.editable=true;
		// 	}else{
		// 		//deshabilita edicion
		// 		this.editable=false;
		// 	}
		// //es un nuevo formulario con localizacion de referencia?
		// }else if(this.isNew==-2){
		// 	this.editable=true;
		// }else{
		// 	//habilita edicion
		// 	this.editable=true;
		// }
		// console.log("FormLocation: "+this.isNew+"+"+this.copyFromId+" editable="+this.editable);
	},

	watch: {
		// isNew: function(newValue, oldValue) {
		// 	console.log("watch isNew: "+newValue+" - "+oldValue);
		// 	console.log("watch: "+this.isNew+"-"+(!this.place.name));
		// 	if (this.isNew && !this.place.name) return (this.editable = true);
		// 	this.editable = false;
		// },
		// isNew: function(newValue, oldValue) {
		// 	console.log("watch isNew: "+newValue+" - "+oldValue+" value:"+this.place.name);
		// 	// console.log("watch: "+this.isNew+"-"+(!this.place.name));

		// 	// if (this.isNew && !this.place.name) return (this.editable = true);
		// 	// this.editable = false;
		// },

		search: debounce(function(term) {
			this.searchPlace(term);
		}, 500),
		formTypeWork:function(newValue, oldValue){
			console.log("Location input service:"+newValue+" -> "+oldValue +" : "+this.place.name);
			this.initialize();
		}
	},
	computed: {
		locationUrl() {
			if (this.place.latitude && this.place.longitude) {
				return `https://www.google.com/maps/search/?api=1&query=${this.place.latitude},${this.place.longitude}`;
			} else {
				return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
					this.place.name
				)}`;
			}
		},
		placeTypeIcon() {
			let icon = "location_on";
			if (this.place.isAirport) icon = "flight";
			return icon;
		},
		placeHasValidLocation() {
			return (
				this.place.latitude !== null && this.place.longitude !== null
			);
		}
	},
	methods: {
		initialize(){
			if(this.formTypeWork=="viewForm" || this.formTypeWork=="newFormCopy" || this.formTypeWork=="newFormLocationReferences"){
				this.editable=true;
			}else{
				this.editable=false;
			}
			this.searchPlace(this.search);
		},
		openPlace(id) {
			this.$refs.placeSingle.loadModel(id);
		},
		searchPlace(term) {
			if (term !== "") {
				this.loading = true;
				api(this)
					.post(`/places/search`, { term })
					.then(res => {
						console.log(res);
						this.searchData = JSON.parse(JSON.stringify(res.data));
						this.loading = false;
					})
					.catch(err => {
						console.log(err);
					});
			}
		},
		setPlace(place) {
			this.$emit("update:place-id", place.id);
			this.$emit("update:place", JSON.parse(JSON.stringify(place)));
			// habilita edicion para bloquear la edicion
			this.editable = true;
		}
	}
};
</script>
